(function AgentSignaturesForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'AgentSignatures',
	};

	var section_regex = /.+\[.+\]\[(\w+)\]/;

	var updateTitle = Adzuki.Debounce(function updateTitle(title)
	{
		// sanitize string to prevent local xss, then nl2br for display
		var _title = Adzuki.String.sanitize(title);
		_title = Adzuki.String.nl2br(_title);
		$('[data-section="title"]').html(_title);
	}, 250);

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		updateTitle($('textarea.title').val());

		// iterate through all checkboxes and update preview
		$.each($('input:visible, textarea', 'form[name="AgentSignatures"]'), function restorePreview(i, el)
		{
			var $self      = $(el),
			    section    = $self.prop('name').match(section_regex)[1],
			    specialist = $self.attr('id');

			if ($self.prop('type') === 'checkbox') {
				// SET-21 / S56: cpmail_compatible was tested here too. The control is gone - it
				// saved for one session and load() overwrote it with 0 on the next - and the
				// current webmail takes rendered content like Outlook and Mac Mail, so the
				// default copy path already serves it.
				if (section === 'mac_compatible' && $self.prop('checked')) {
					$(".email-signature").addClass('hidden');
					$(".email-signature.mac-box").removeClass('hidden');
				} else if (!$self.prop('checked')) {
					$('[data-section="'+section+'"]').toggle();
					$('[data-specialist="'+specialist+'"]').toggle();
				}
			}
		});

		$("input.toggle-section").click(function toggleSection() {
			var section = $(this).prop('name').match(section_regex)[1];
			$('[data-section="'+section+'"]').toggle();
		});

		$("input.toggle-logo").click(function toggleLogo() {
			var section = $(this).prop('name').match(section_regex)[1];
			$('[data-section="'+section+'"]').toggle();

			if ($(this).prop('checked')) {
				$(".cp-logos").removeClass('hidden');
			} else {
				$(".cp-logos").addClass('hidden');
			}
		});

		$("select.cp-logo-image").change(function updateLogo() {
			var logo      = $(this).val(),
			    logo_file = $('#'+logo).val();

			$('.cp-logo-file').attr('src', logo_file);
		});

		$("input.toggle-specialist").click(function toggleSpecialist() {
			var specialist_id = $(this).attr('id');
			$('[data-specialist="'+specialist_id+'"]').toggle();
			$('[data-disclaimer="'+specialist_id+'"]').toggle();
		});

		$("input.mac").click(function toggleMacSignature() {
			if ($(this).is(':checked')) {
				$(".email-signature").addClass('hidden');
				$(".email-signature.mac-box").removeClass('hidden');
			} else {
				$(".email-signature").removeClass('hidden');
				$(".email-signature.mac-box").addClass('hidden');
			}
		});

		$('textarea.title').on('keyup', function _updateTitle() {
			updateTitle($(this).val());
		});

		$("a.suggested-title").click(function insertSuggestedTitle(e)
		{
			e.preventDefault();

			// KEYUP DRIVES THE PREVIEW, CHANGE DRIVES THE SAVE BUTTON - SET-21.
			//
			// This fired keyup alone, which is what updateTitle() listens for, so the signature
			// followed the pill immediately. But My Settings' dirty tracker watches `change` and
			// `input` on the fields that post, and a value set by script fires neither - so the
			// advisor could pick a suggested title, watch the preview update, and find Save still
			// disabled. Harmless on the legacy screen, which has its own always-live save button.
			$('textarea.title').val($(this).text()).trigger('keyup').trigger('change');
		});

		$('.copy-to-clipboard').click(function copyToClipboard(e)
		{
			// this needs to copy the /rendered/ markup of the signatures,
			// not the markup itself (Outlook will just paste in raw HTML).
			// https://developer.mozilla.org/en-US/docs/Web/API/Range
			// https://developer.mozilla.org/en-US/docs/Web/API/Selection
			var $signature = $('.email-signature:not(.hidden)'),
			    range,
			    selection;

			e.preventDefault();

			// SET-21 / S56: THE OTHER BRANCH IS GONE. It copied the RAW HTML SOURCE into a hidden
			// input because SOGo wanted source; SOGo is retired and the current webmail takes
			// rendered content like Outlook and Mac Mail, so one path now serves every client.
			if (!document.createRange && !document.setSelection) {
				// we shouldn't ever hit this; adzuki targets new browsers
				Adzuki.StatusMessage('Error', 'Your browser does not support this feature.');
				return;
			}

			// create a new Range object
			range = document.createRange();

			// get whatever's currently selected, if anything.
			// this returns a Selection object regardless.
			selection = document.getSelection();

			// just in case a user has other stuff selected, unselect them
			selection.removeAllRanges();

			// get the signature node fragment
			range.selectNodeContents($signature[0]);

			// add range to selection
			selection.addRange(range);

			// actually copy to clipboard
			if (!document.execCommand('copy')) {
				Adzuki.StatusMessage('Error', 'Error copying signature to clipboard.');
				return;
			}

			// unselect signature node so it doesn't look weird
			document.getSelection().removeAllRanges();

			Adzuki.StatusMessage('Success', 'Your signature has been copied to your clipboard.');
		});

		// THE SIGNATURE IS CAPTURED IN beforeSubmit, NOT ON submit - SET-21.
		//
		// This hung off `.btn-save`, the save button INSIDE the legacy screen's form. My Settings
		// has no such button - S26 puts one Save in the modal's top bar and it calls
		// $form.submit() directly - so the hidden field was never populated and the save stored an
		// empty signature.
		//
		// MOVING IT TO THE FORM'S OWN submit FIXED THE WRONG HALF OF THAT, and QA found the rest.
		// form.js binds _submit in _initForm() and calls this load() afterwards, so a handler
		// bound here is always second and jQuery fires them in order: the payload was taken
		// before the capture ran, and the save stored whatever the panel had been RENDERED with.
		// The stored row kept an old signature - in one case still carrying another developer's
		// base path - while the title saved beside it updated every time.
		//
		// NOTHING ON SCREEN DISAGREED, which is why it survived review: the preview is built live
		// from the settings rather than from the stored html, so it showed the new signature
		// whatever was in the column.
		//
		// beforeSubmit runs immediately before `new FormData` - the only position that answers
		// "write the field, then let it be read".
		form.beforeSubmit = function captureSignature() {
			$('#agentsignatures-signature').val(
				'<table cellspacing="1" cellpadding="2">'
				+ $('.email-signature:not(.hidden)').html()
				+ '</table>'
			);
		};

		$('.btn-save').on('click', function submitForm(e) {
			e.preventDefault();

			$(form.element).submit();
		});
	};
}(jQuery, window.Adzuki || {}));
